export default __webpack_public_path__ + "img/in-the-forest.webp";